<ion-row class="row ion-text-center">
    <ion-col>
        <ion-button [disabled]="isLoading" class="bar-button" color="gray" (click)="getTie()" expand="block" fill="clear">
            @if (!isLoading) {
                <div>
                    <ion-icon name="cloud-download-outline"></ion-icon>
                    <span>Download</span>
                </div>
            } @else {
                <ion-spinner name="crescent"></ion-spinner>
            }
        </ion-button>
    </ion-col>
</ion-row>